export class VisibilityData {
  visibilityTypeId: number;
  isPredefined: boolean = false; // in default it's not predefined
}
